import React from 'react'
import { withStyles } from '@material-ui/core'
import styles from './styles'
import { createCourseTemplate } from 'src/components/editor/components/custom-plugins/simple-box/course-outline-template'
import { useSelector } from 'react-redux'
import CreateCollectionTemplate from 'src/components/editor/components/custom-plugins/simple-box/collection-outline-template'

const Outline = props => {
  const { classes, pageUrl } = props
  const courses = useSelector(state => state.collection.courses)

  const courseCards = useSelector(state => state.course.courseCards)
  const landingPageData = useSelector(state => state.course.landingPageSettings)
  const isEdit = false

  return (
    <div
      className={
        pageUrl === 'mini-course' ? classes.container : classes.collection
      }
    >
      {pageUrl === 'mini-course' ? (
        <div
          className={classes.content}
          dangerouslySetInnerHTML={{
            __html: createCourseTemplate(courseCards, landingPageData),
          }}
        />
      ) : (
        <div
          className={classes.collectionContent}
          dangerouslySetInnerHTML={{
            __html: CreateCollectionTemplate(courses, null, isEdit),
          }}
        />
      )}
    </div>
  )
}

export default withStyles(styles)(Outline)
